import { useReferralDiscount } from "@/hooks/useReferralDiscount";

/**
 * 상단 referral 배너용 표시 문자열(`"15 %"`). 활성 referral 이 없으면 **null**.
 *
 * ⚠️ 쿠키를 직접 읽지 않고 `useReferralDiscount` 를 통한다.
 *
 * 배너와 가격이 **각자 쿠키를 파싱하면 판정이 갈릴 여지**가 생기고(#5227 에서 만료 처리를
 * 넣었을 때 실제로 갈렸다 — 가격은 정가인데 배너만 할인을 계속 광고했다), 같은 쿠키를 두 번
 * 판다. 만료 처리 자체는 되돌렸지만(#5258) **단일 소스 원칙은 유지한다.**
 */
export const useReferral = () => {
  const { referralDiscountPercentile } = useReferralDiscount();

  const percentile =
    referralDiscountPercentile > 0
      ? `${(referralDiscountPercentile * 100).toFixed()} %`
      : null;

  return { percentile };
};
